module.exports = __webpack_public_path__ + "static/media/animal_08.44e3e98a.png";